"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parsePaymentMethods = exports.PAYMENT_METHODS = void 0;
exports.PAYMENT_METHODS = {
    CARD: "direct credit card",
    PAYPAL: "paypal",
    APPLE: "apple pay",
};
const PAYMENT_METHODS_LABELS = {
    CARD: "Card",
    PAYPAL: "PayPal Account",
    APPLE: "Apple Pay",
};
const getCardPaymentMethod = (method) => {
    const cardInfo = method.cardInfoMessage;
    return Object.assign({ label: method.label, type: exports.PAYMENT_METHODS.CARD, paymentmethodInfo: {
            label: "Card",
            cardInfoMsg: { paymentMethodId: cardInfo.paymentMethodId },
        } }, cardInfo);
};
const getPaypalPaymentMethod = (method) => {
    const paypalInfo = method.PayPalAccountMessage;
    return Object.assign({ label: method.label, type: exports.PAYMENT_METHODS.CARD, paymentmethodInfo: {
            label: "PayPalAccount",
            paypalAccountMsg: { paymentMethodId: paypalInfo.paymentMethodId },
        } }, paypalInfo);
};
const getApplePaymentMethod = (method) => {
    const appleInfo = method.ApplePayInfoMessage;
    return Object.assign({ label: method.label, type: exports.PAYMENT_METHODS.CARD, paymentmethodInfo: {
            label: "ApplePay",
            cardInfoMsg: { paymentMethodId: appleInfo.paymentMethodId },
        } }, appleInfo);
};
const parsePaymentMethodByLabel = (method) => {
    switch (method.label) {
        case PAYMENT_METHODS_LABELS.CARD:
            return getCardPaymentMethod(method);
        case PAYMENT_METHODS_LABELS.PAYPAL:
            return getPaypalPaymentMethod(method);
        case PAYMENT_METHODS_LABELS.APPLE:
            return getApplePaymentMethod(method);
    }
};
function parsePaymentMethods({ PaymentMethods = [], }) {
    const labels = Object.values(PAYMENT_METHODS_LABELS);
    const pms = PaymentMethods.filter(({ status = "", isAutoPayment = false }) => status === "Active" && isAutoPayment).filter(({ label = "" }) => labels.includes(label));
    const paymentMethods = pms.map(parsePaymentMethodByLabel);
    const hasPaymentMethods = paymentMethods.length > 0;
    const methods = hasPaymentMethods ? paymentMethods : [];
    return {
        methods,
        hasPaymentMethods,
    };
}
exports.parsePaymentMethods = parsePaymentMethods;
//# sourceMappingURL=PaymentMethods.js.map